<template>
  <div class="UtahNotice">
    <h2 class="UtahNotice_Heading">UTAH PRIVACY NOTICE</h2>

    <p>
      If you are a Utah resident, you have the following rights as of December
      31, 2023:
    </p>

    <p>
      <span class="UtahNotice_ItemTitle">Right to Access:</span>
      You may have the right to confirm whether or not we are processing your
      Personal Information and to access such Personal Information.
    </p>

    <p>
      <span class="UtahNotice_ItemTitle">Right to Correction:</span>
      You may have the right to correct inaccuracies in your Personal
      Information, taking into account the nature of the Personal Information
      and the purposes of the processing of your Personal Information.
    </p>

    <p>
      <span class="UtahNotice_ItemTitle">Right to Deletion:</span>
      You may have the right to delete the Personal Information provided to us
      by you.
    </p>

    <p>
      <span class="UtahNotice_ItemTitle">Right to Data Portability:</span>
      You may have the right to obtain a copy of the Personal Information that
      you previously provided to us in a portable and, to the extent technically
      feasible, readily usable format that allows you to transmit your Personal
      Information to another controller without hindrance, where the processing
      is carried out by automated means.
    </p>

    <p>
      <span class="UtahNotice_ItemTitle"
        >Right to Opt-Out of Sale, Targeted Advertising, and Profiling:</span
      >
      For purposes of UCPA, a “sale” includes disclosing Personal Information to
      a third party in exchange for monetary compensation. We do not “sell”
      Personal Information under this definition. Utah residents have the right
      to opt out of the processing of your Personal Information by us for
      decisions that produce legal or similarly significant effects concerning
      you. We do not process Personal Information for such profiling. We do
      share your Personal Information for targeted advertising purposes as we
      describe in the Privacy Policy to make the Service available to you. For
      example, we may disclose information to advertising partners, advertising
      technology companies, and companies that perform advertising-related
      services in order to improve the relevance of our advertising and
      marketing. To the extent possible, Grove Collaborative excludes Personal
      Information from Utah residents from these activities.
    </p>

    <p>
      If you are a resident of Utah and wish to exercise any of your rights
      under the UCPA, you or your authorized agent may make a request to
      confirm, access, correct, delete, obtain a copy, or opt-out of the
      processing of your Personal Information for targeting advertising by
      submitting a Privacy Request Form
      <SkyLink
        inline
        to="https://preferences.grove.co/privacy"
        target="_blank"
        tag="a"
        >here</SkyLink
      >, or by emailing
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co.</SkyLink
      >
      Please indicate that you are making a request pursuant to your “Utah
      Privacy Rights” and provide us with the requested information to verify
      your request. We will take steps to verify your request by matching the
      information provided by you with the information we have in our records.
    </p>
  </div>
</template>

<style lang="scss">
.UtahNotice {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
    text-align: center;
  }

  &_ItemTitle {
    text-decoration: underline;
  }
}
</style>
